<template>
  <div class="product__price-wrapper">
    <a-product-base-price
      :regular="price.regular"
      :special="price.special"
      :factor="product.baseprice_product_amount"
      :unit="product.baseprice_product_unit"
      v-if="product.baseprice_product_unit"
    />
    <div class="product__price">
      <div class="unit" v-if="product.vk_einheit">
        pro <a-product-unit :product="product" :unit="product.vk_einheit" :qty="1" />
      </div>
      <SfPrice
        :regular="regularPrice"
        :special="specialPrice"
        :class="[ product.baseprice_product_unit ? '' : 'default' ]"
      />
    </div>
    <div class="taxes">
      Inkl. 19% MwSt., zzgl.
      <router-link :to="localizedRoute('/versandkosten')">
        Versand
      </router-link>
      <!--<a @click="viewShippingCosts">Versand</a>-->
    </div>
  </div>
</template>
<script>
import { SfPrice } from '@storefront-ui/vue';
import { getProductPrice } from 'theme/helpers'
import { price } from '@vue-storefront/core/filters/price'
import AProductBasePrice from 'theme/components/atoms/a-product-base-price';
import AProductUnit from 'theme/components/atoms/a-product-unit'

import { mapActions } from 'vuex'
import { ModalList } from 'theme/store/ui/modals'

export default {
  name: 'AProductPrice',
  components: {
    SfPrice,
    AProductBasePrice,
    AProductUnit
  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    customOptions: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    price () {
      return getProductPrice(this.product, this.customOptions)
    },
    regularPrice () {
      return price(getProductPrice(this.product, this.customOptions).regular)
    },
    specialPrice () {
      let special = getProductPrice(this.product, this.customOptions).special
      return special ? price(special) : null
    }
  },
  methods: {
    ...mapActions('ui', {
      openModal: 'openModal'
    }),
    viewShippingCosts () {
      this.openModal({ name: ModalList.ShippingCosts, payload: this.product })
    }
  }
}
</script>
